import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ModalComponent, QrComponent } from '@tecalisdev/infinity';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'app-modal-change-device',
	templateUrl: './modal-change-device.component.html',
	styleUrls: ['./modal-change-device.component.scss'],
	imports: [ModalComponent, QrComponent, TranslatePipe],
})
export class ModalChangeDeviceComponent {
	private configService = inject(ConfigService);

	@Input() isVisible: boolean;
	@Input() url: string;
	@Output() isVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor() {}

	get hasActiveRecording(): boolean {
		return this.configService.getCurrentConfig()?.required_recording || false;
	}

	public closeModal(): void {
		this.isVisible = false;
		this.isVisibleChange.emit(false);
	}
}
